export const mapBasePath = '/map';

// dynamically setup basename path based off accountBasePath constant
export const pathBeforeBase = document.location.pathname.split(mapBasePath)[0];

export const appBaseName = document.location.pathname.indexOf(mapBasePath) > -1 ? `${pathBeforeBase}${mapBasePath}` : '';
